import React,{useState,useEffect} from 'react';
import './Testimonials.css';
import { testimonialsList } from '../data';
function Testimonials(){
  const [cur,setCur]=useState(0);
  useEffect(()=>{const t=setInterval(()=>setCur(c=>(c+1)%testimonialsList.length),4500);return()=>clearInterval(t);},[]);
  return(
    <section className="testimonials section">
      <div className="container">
        <span className="section-label">Happy Clients</span>
        <h2 className="section-heading">What They <em>Say</em></h2>
        <div className="t-wrap">
          {testimonialsList.map((t,i)=>(
            <div key={i} className={`t-card ${i===cur?'active':''}`}>
              <div className="t-stars">★★★★★</div>
              <p className="t-quote">"{t.text}"</p>
              <span className="t-name">{t.name}</span>
              <span className="t-event">{t.event}</span>
            </div>
          ))}
          <div className="t-dots">{testimonialsList.map((_,i)=><button key={i} className={`tdot ${i===cur?'on':''}`} onClick={()=>setCur(i)}/>)}</div>
        </div>
      </div>
    </section>
  );
}
export default Testimonials;
